import { useXGScale } from '@statsbomb/kitbag-datavis';
import { useAtomValue } from 'jotai';
import { useTheme } from 'styled-components';
import { pitchMarkerColouringModeAtom } from '@/atoms/visualisation';
import { GOAL_OUTCOME, OWN_GOAL_TYPE, SAVED_SHOT_OUTCOMES } from '@/consts/visualisations';
import { ShotMapEventMarker } from '@/types/visualisation';
import { isNullish } from '@/utils/predicates';
import { useObvScale } from '../useObvScale';

export const useShotMarkerStroke = () => {
  const theme = useTheme();
  const { dataObjects } = theme.colours.visualisations;
  const getXgColor = useXGScale();
  const getObvColor = useObvScale();
  const colouringMode = useAtomValue(pitchMarkerColouringModeAtom);

  const getMarkerStroke = (event: ShotMapEventMarker) => {
    if (
      event.type === OWN_GOAL_TYPE ||
      event.outcome === GOAL_OUTCOME ||
      SAVED_SHOT_OUTCOMES.includes(event.outcome!)
    ) {
      return dataObjects.inverse;
    }
    if (colouringMode === 'obv') return isNullish(event.obv) ? dataObjects.neutral.main : getObvColor(event.obv);
    return getXgColor(event.xg ?? 0);
  };

  return getMarkerStroke;
};
